<script>
import { PMREMGenerator, UnsignedByteType } from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

//import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
//import * as THREE from "three/build/three.module.js";
import mixin from "./AugmentableMixin.vue";

//import { USDZExporter } from "three/examples/jsm/exporters/USDZExporter.js";

//import { Epsilon } from "@babylonjs/core";

//import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
//import Stats from "three/examples/jsm/libs/stats.module.js";

//let scene, renderer, camera;
//let model;

// const crossFadeControls = [];

// let idleAction, walkAction, runAction;
// let idleWeight, walkWeight, runWeight;
//let actions, settings;

// let singleStepMode = false;
// let sizeOfNextStep = 0;

export default {
  name: "AugmentableGltf",
  mixins: [mixin],
  components: {},
  props: {
    src1: String,
    lights: {
      type: Array,
      default() {
        return [
          {
            type: "AmbientLight",
            color: 0xaaaaaa,
          },
          {
            type: "DirectionalLight",
            position: { x: 1, y: 1, z: 1 },
            color: 0xffffff,
            intensity: 0.8,
          },
        ];
      },
    },
    gammaOutput: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    //threejs
    //alert(this.src);
    //this.init();
    //threejs
  },

  data: function () {
    //const loader = new GLTFLoader(this.manager);
    const loader = this.gltfLoader;
    loader.setCrossOrigin(this.crossOrigin);
    loader.setRequestHeader(this.requestHeader);
    return {
      loader,
      //model,
    };
  },
  methods: {
    load() {
      if (!this.src) return;
      if (this.object) {
        this.wrapper.remove(this.object);
      }

      //let { model } = this;
      //console.log(model);

      this.loader.load(
        this.src,
        async (data) => {
          data.scene.traverse((n) => {
            if (n.isMesh) {
              n.castShadow = true;
              n.receiveShadow = true;
              if (n.material.map) {
                n.material.map.anisotropy = 16;
              }
            }
          });

          // data.scene.traverse(function (object) {
          //   if (object.material) {
          //     console.log("materialFound");
          //     console.log(object.material);
          //     // materials.add( object.material );
          //   }
          // });
          //console.log(data.scene);
          this.addObject(data.scene);
          //console.log("fggfgfgfggfg");
          // let model = this.model;
          this.modelLoad = data;

          // this.mixer = new AnimationMixer(data.scene);
          // this.mixer.clipAction(data.animations[0]).play();

          // console.log("wwwww");
          // console.log(this.model.animations);
          //this.mixer = new AnimationMixer(data.scene);
          //console.log(this.model);
          //console.log("cvcvcvcv");

          // const exporter = new USDZExporter();
          // const arraybuffer = await exporter.parse(data.scene);
          // const blob = new Blob([arraybuffer], {
          //   type: "application/octet-stream",
          // });

          // var link = document.createElement("a");
          // link.download = "hello.usdz";
          // link.rel = "ar";
          // link.href = URL.createObjectURL(blob);
          // link.click();

          this.$emit("on-load");
        },
        (xhr) => {
          this.$emit("on-progress", xhr);
        },
        (err) => {
          this.$emit("on-error", err);
        }
      );
    },
    changeEnvironmentImage() {
      let { environmentImage } = this;

      if (!this.src) return;

      let { scene } = this;
      if (environmentImage) {
        const pmremGenerator = new PMREMGenerator(this.renderer);
        pmremGenerator.compileEquirectangularShader();
        new RGBELoader()
          .setDataType(UnsignedByteType)
          .load(environmentImage, function (texture) {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;

            scene.environment = envMap;

            texture.dispose();
            pmremGenerator.dispose();
          });
      }
      // else {
      //   //console.log("3rd");
      // }
    },
    changeSkyboxImage() {
      let { skyboxImage } = this;

      if (!this.src) return;

      let { scene } = this;
      if (skyboxImage) {
        const pmremGenerator = new PMREMGenerator(this.renderer);
        pmremGenerator.compileEquirectangularShader();
        new RGBELoader()
          .setDataType(UnsignedByteType)
          .load(skyboxImage, function (texture) {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;

            scene.background = envMap;

            texture.dispose();
            pmremGenerator.dispose();
          });
      } else {
        scene.background = null;
      }
    },
    changeExposure() {
      let { exposure } = this;
      let { renderer } = this;
      renderer.toneMappingExposure = exposure;
    },
    // init() {
    //   //const container = document.getElementById("container");

    //   // camera = new THREE.PerspectiveCamera(
    //   //   45,
    //   //   window.innerWidth / window.innerHeight,
    //   //   1,
    //   //   1000
    //   // );
    //   // camera.position.set(1, 2, -3);
    //   // camera.lookAt(0, 1, 0);
    //   // camera = new THREE.PerspectiveCamera(
    //   //   45,
    //   //   window.innerWidth / window.innerHeight,
    //   //   0.25,
    //   //   20
    //   // );
    //   // camera.position.set(-1.8, 0.6, 2.7);

    //   //clock = new THREE.Clock();

    //   scene = new THREE.Scene();
    //   // scene.background = new THREE.Color(0xa0a0a0);
    //   // scene.fog = new THREE.Fog(0xa0a0a0, 10, 50);

    //   // const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
    //   // hemiLight.position.set(0, 20, 0);
    //   // scene.add(hemiLight);

    //   // const dirLight = new THREE.DirectionalLight(0xffffff);
    //   // dirLight.position.set(-3, 10, -10);
    //   // dirLight.castShadow = true;
    //   // dirLight.shadow.camera.top = 2;
    //   // dirLight.shadow.camera.bottom = -2;
    //   // dirLight.shadow.camera.left = -2;
    //   // dirLight.shadow.camera.right = 2;
    //   // dirLight.shadow.camera.near = 0.1;
    //   // dirLight.shadow.camera.far = 40;
    //   // scene.add(dirLight);

    //   // scene.add( new THREE.CameraHelper( dirLight.shadow.camera ) );

    //   // ground

    //   // const mesh = new THREE.Mesh(
    //   //   new THREE.PlaneGeometry(100, 100),
    //   //   new THREE.MeshPhongMaterial({ color: 0x999999, depthWrite: false })
    //   // );
    //   // mesh.rotation.x = -Math.PI / 2;
    //   // mesh.receiveShadow = true;
    //   // scene.add(mesh);

    //   const loader = new GLTFLoader();

    //   loader.load(
    //     this.src,
    //     function (gltf) {
    //       this.addObject(gltf.scene);
    //       this.$emit("on-load");
    //     },
    //     (xhr) => {
    //       this.$emit("on-progress", xhr);
    //     },
    //     (err) => {
    //       this.$emit("on-error", err);
    //     }
    //   );
    //   // {
    //   //     model = gltf.scene;
    //   //     console.log(model);
    //   //     scene.add(model);

    //   //     // model.traverse(function (object) {
    //   //     //   if (object.isMesh) object.castShadow = true;
    //   //     // });

    //   //     //

    //   //     // skeleton = new THREE.SkeletonHelper(model);
    //   //     // skeleton.visible = false;
    //   //     // scene.add(skeleton);

    //   //     //

    //   //     //this.createPanel();

    //   //     //

    //   //     const animations = gltf.animations;
    //   //     console.log(animations);

    //   //     // mixer = new THREE.AnimationMixer(model);

    //   //     // idleAction = mixer.clipAction(animations[0]);
    //   //     // walkAction = mixer.clipAction(animations[3]);
    //   //     // runAction = mixer.clipAction(animations[1]);

    //   //     //actions = [idleAction, walkAction, runAction];

    //   //     //this.activateAllActions();

    //   //     //this.animate();
    //   //   },
    //   //   undefined,
    //   //   function (error) {
    //   //     console.error(error);
    //   //   }
    //   // );

    //   alert("jhjkkj");

    //   // renderer = new THREE.WebGLRenderer({ antialias: true });
    //   // renderer.setPixelRatio(window.devicePixelRatio);
    //   // renderer.setSize(window.innerWidth, window.innerHeight);
    //   // renderer.toneMapping = THREE.ACESFilmicToneMapping;
    //   // renderer.toneMappingExposure = 1;
    //   // renderer.outputEncoding = THREE.sRGBEncoding;
    //   // container.appendChild(renderer.domElement);

    //   // const pmremGenerator = new THREE.PMREMGenerator(renderer);
    //   // pmremGenerator.compileEquirectangularShader();

    //   // const controls = new OrbitControls(camera, renderer.domElement);
    //   // controls.addEventListener("change", this.render); // use if there is no animation loop
    //   // controls.minDistance = 2;
    //   // controls.maxDistance = 10;
    //   // controls.target.set(0, 0, -0.2);
    //   // controls.update();

    //   // window.addEventListener("resize", this.onWindowResize);

    //   // stats = new Stats();
    //   // container.appendChild(stats.dom);

    //   // window.addEventListener("resize", this.onWindowResize);
    // },
    // onWindowResize() {
    //   camera.aspect = window.innerWidth / window.innerHeight;
    //   camera.updateProjectionMatrix();

    //   renderer.setSize(window.innerWidth, window.innerHeight);

    //   this.render();
    // },
    // render() {
    //   renderer.render(scene, camera);
    // },
  },
};
</script>
